import { container } from "./infrastructure/ioc/container-configuration";
import { CONTAINER_TYPES } from "./infrastructure/ioc/container-types";
import { ApplicationInterface } from "./infrastructure/setup/application-interface";

const application = container.get<ApplicationInterface>(
  CONTAINER_TYPES.ApplicationInterface
);
application.run();
